import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';

export function isProviderLoggedIn() {
  try {
    return Boolean(localStorage.getItem('accessToken') && localStorage.getItem('idToken'));
  } catch {
    return false;
  }
}

export function getBrandHomePath(isLoggedIn = isProviderLoggedIn()) {
  return isLoggedIn ? '/provider/' : '/';
}

/**
 * Elegant serif monogram on a dark tile — an abstract, professional
 * logomark (no literal cup). Reads like a considered hospitality brand.
 */
export function BrandMark({ size = 'md' }) {
  return (
    <span
      className={[
        'provider-brand-mark',
        size === 'lg' ? 'provider-brand-mark--lg' : '',
        size === 'sm' ? 'provider-brand-mark--sm' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      aria-hidden="true"
    >
      <span className="provider-brand-glyph">R</span>
    </span>
  );
}

/**
 * @param {string|null} to - explicit destination; omit when using smartHome
 * @param {boolean} smartHome - logged out → /, logged in → /provider/
 */
export function BrandLogo({ to, smartHome = false, showTagline = true, className = '' }) {
  const { user } = useAuth();
  const isLoggedIn = Boolean(user) || isProviderLoggedIn();
  const resolvedTo = smartHome ? getBrandHomePath(isLoggedIn) : to;

  const content = (
    <>
      <BrandMark />
      <span className="provider-brand-text">
        <span className="provider-brand-name">ReTechSys</span>
        {showTagline && <span className="provider-brand-tagline">Provider Portal</span>}
      </span>
    </>
  );

  if (resolvedTo === '/' && !isLoggedIn) {
    return (
      <a href="/" className={`provider-brand ${className}`}>
        {content}
      </a>
    );
  }

  if (resolvedTo) {
    return (
      <Link to={resolvedTo} className={`provider-brand ${className}`}>
        {content}
      </Link>
    );
  }

  return <div className={`provider-brand ${className}`}>{content}</div>;
}

export default BrandLogo;
